import _ from 'lodash';

import { cleanUpActiveSession } from './cleanup_active_session';
import { getOfferedSessionForAgent } from './session_finder';
import RoutingEventType from 'models/routing_event/routing_event_type';
import SystemNotificationGenerator from 'scripts/domain/contracts/system_notification_generator';

export default class DeclineConcurrentMessagingSession {
  constructor(context) {
    this.context = context;
  }

  run() {
    const currentAgentId = this.context.stores.currentAgent.get().id;
    let offeredSession = getOfferedSessionForAgent(this.context.stores.activeSessions, currentAgentId);
    if (!offeredSession) {
      return;
    }

    this.context.capacityManager.postponeMessagingRouting();
    let newConversationPreviews = _.filter(this.context.stores.inbox.get(), preview => {
      if (!preview.conversationItem) {
        return true;
      }
      return offeredSession.id !== preview.conversationItem.content.sessionId;
    });
    this.context.stores.inbox.set(newConversationPreviews);

    cleanUpActiveSession(this.context, offeredSession);
    SystemNotificationGenerator.closeNotification(offeredSession.id);
    this.context.gateways.routingEvent.publish(currentAgentId, {
      queueItemId: offeredSession.id,
      reason: REASON_AGENT_DECLINED,
      type: RoutingEventType.DECLINED_OFFERED_CONCURRENT_SESSION,
    });
  }
}

const REASON_AGENT_DECLINED = 'DECLINED';



// WEBPACK FOOTER //
// ./src/scripts/application/actions/concurrent_messaging/decline_concurrent_messaging_session.js